import { components } from '@/config/components';
import { fit } from '@/assets/static/fit/index'; // 适配不同屏幕
import * as Echarts from 'echarts';
import * as FN from '@/public';
import * as RULES from '@/public/rules';
import * as Dictionary from '@/public/dictionary'; //字典
import DictionaryMethods from '@/public/dictionary'; //字典
import Antd from 'ant-design-vue';
// import VueQuillEditor from 'vue-quill-editor';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import Vuex from '@/store';
import { t } from '@/locales';

// 页面需要登录才可以进入
export const verification = to => {
  // loginTip 如果为true就需要验证是否登录
  let { loginTip = false } = to.meta;
  let config = { content: t('common.notLoggedIn') };
  if (loginTip && !FN.getUser()) FN.LoginTips(config);
};

// 路由守卫
export const beforeEachRouter = router => {
  router.beforeEach((to, form, next) => {
    if (to.path === '/') {
      next("/home");
    } else {
      if (!FN.getUser()) {
        if ((to.path != "/home") && (to.path != "/forget")) {
          let config = { content: t('common.notLoggedIn') };
          FN.LoginTips(config);
          next("/home");
        } else {
          next();
        }
      } else {
        if (to.path === "/forget") {
          next("/home");
        } else {
          next();
        };
        // verification(to);
      };
    }
  });
};

// 加载公共组件
export const registerCom = Vue => components.map(item => {
  let name = '';
  name = item.split('/')[item.split('/').length - 1];
  Vue.component(name, () => import(`@/components/${item}`));
});

// 挂载第三方插件
export const use = Vue => {
  Vue.use(VueAwesomeSwiper, /* { default global options } */);
  Vue.use(Antd);
  // Vue.use(VueQuillEditor);
};

// 自定义指令
export const directive = Vue => {
  // 平滑上升动画
  const slideIn = () => {
    let map = new WeakMap();
    let newMap = new WeakMap();

    // 判断元素是否在窗口之下
    const isBelowViewport = el => {
      return new Promise(a => {
        let time = setTimeout(() => {
          const rect = el.getBoundingClientRect();
          a(rect.top > window.innerHeight);
          clearTimeout(time);
          time = null;
        }, 300);
      });
    };

    Vue.directive('slide-in', {
      bind: async function (el) {
        let value = await isBelowViewport(el);
        if (!value) return;

        let visible = FN.elVisible(
          (target, _, subsidiary) => {
            let animation = map.get(target);
            animation && animation.play();
            subsidiary.unobserve(target);
          },
          { visible: false, rootMargin: "0px" }
        );
        visible([el]);
        const animation = el.animate(
          [
            {
              transform: `translateY(50px)`,
              opacity: 0.5
            },
            {
              transform: `translateY(0)`,
              opacity: 1
            }
          ],
          {
            duration: 300,
            easeing: 'ease-out',
            fill: 'forwards'
          }
        );
        animation.pause();
        map.set(el, animation);
      }
    });
  };
  slideIn();
};

// 执行所有的字典方法
export const created = () => {
  // 禁止调用调试
  // FN.prohibit();
  // 优先获取权限
  FN.getRoles();
  // 再执行其它接口
  DictionaryMethods.forEach(item => item());
};

// 持久化操作
export const persistence = () => {
  let value = FN.getLC('language');
  if (value) Vuex.commit('setLanguage', value);
};

// 处理冗余导航报错
export const redundantNavigation = router => {
  const originalPush = router.push.bind(router);
  const originalReplace = router.replace.bind(router);
  
  router['__proto__'].$push = function (location) {
    return originalPush(location).catch(err => {
      // 重复导航的时候,回到顶部,并刷新页面
      let LayoutHeader = document.getElementById("LayoutHeader");
      if (LayoutHeader) {
        LayoutHeader.scrollTop = 0;
      }
      Vuex.commit("setLoginStateKey", Math.random());
    })
  };
  router['__proto__'].$replace = function (location) { 
    return originalReplace(location).catch(err => console.log("重复导航!")) 
  };
};

export const create = (Vue, router) => {
  fit();
  Vue.prototype.$FN = FN;
  Vue.prototype.$RULES = RULES;
  Vue.prototype.$ECharts = Echarts;
  Vue.prototype.$L = FN.getLanguage;
  Vue.prototype.t = t;
  Vue.prototype.$BUS = new Vue();
  Vue.prototype.$DC = Dictionary;
  created();
  persistence();
  redundantNavigation(router);
  beforeEachRouter(router);
  registerCom(Vue);
  directive(Vue);
};